import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, resolveDynamicComponent as _resolveDynamicComponent, openBlock as _openBlock, createBlock as _createBlock, KeepAlive as _KeepAlive, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  class: "app-main"
};
import useStore from '@/store';

import { computed } from 'vue';
export default /*@__PURE__*/_defineComponent({
  __name: 'AppMain',
  setup(__props) {
    const store = useStore();
    const cachedViews = computed(() => {
      return store.tagsView.cachedViews;
    });
    return (_ctx, _cache) => {
      const _component_router_view = _resolveComponent("router-view");
      return _openBlock(), _createElementBlock("section", _hoisted_1, [_createVNode(_component_router_view, null, {
        default: _withCtx(({
          Component,
          route
        }) => [(_openBlock(), _createBlock(_KeepAlive, {
          include: _unref(cachedViews),
          max: 20
        }, [(_openBlock(), _createBlock(_resolveDynamicComponent(Component), {
          key: route.fullPath
        }))], 1032, ["include"]))]),
        _: 1
      })]);
    };
  }
});